// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__IpHjm","host":"style_host__iEXLA"};